// constants.js
export const FETCH_MEDIA = 'src/Media/FETCH_MEDIA';
export const FETCH_MEDIAS = 'src/Media/FETCH_MEDIAS';
export const MEDIA_CHANGE = 'src/Media/MEDIA_CHANGE';
export const SET_MEDIA_FORM_ERRORS = 'src/Media/SET_MEDIA_FORM_ERRORS';
export const RESET_MEDIA = 'src/Media/RESET_MEDIA';
export const ADD_MEDIA = 'src/Media/ADD_MEDIA';
export const REMOVE_MEDIA = 'src/Media/REMOVE_MEDIA';
export const UPDATE_MEDIA = 'src/Media/UPDATE_MEDIA';
export const SET_MEDIA_LOADING = 'src/Media/SET_MEDIA_LOADING';
export const SET_MEDIA_EDIT_FORM_ERRORS = 'src/Media/SET_MEDIA_EDIT_FORM_ERRORS';
export const HOME_MEDIA = 'src/Media/HOME_MEDIA';
export const POPOVER_MEDIA = 'src/Media/POPOVER_MEDIA';
